module.exports = __webpack_public_path__ + "media/images/icons/bank-976330f63a45b0bfe184730ad772e0a9.svg";